import { type EditorState } from '@atlaskit/editor-prosemirror/state';

import type { AIDefinitionsPluginConfig } from '../types';

const getSelectedText = (editorState: EditorState) => {
	const { from, to } = editorState.selection;
	const text = editorState.doc.textBetween(from, to, '\n');
	return text.trim();
};

export const selectionHasText = (editorState: EditorState) => {
	if (editorState.selection.empty) {
		return false;
	}
	const text = getSelectedText(editorState);
	return text.length > 0;
};

const selectionWordCount = (editorState: EditorState) => {
	const text = getSelectedText(editorState);
	return text.split(/\s+/).length;
};

const DEFAULT_MAX_WORD_COUNT = 1;

export const selectionExceedsMaxWordCount = (
	editorState: EditorState,
	config: AIDefinitionsPluginConfig,
) => {
	const wordCount = selectionWordCount(editorState);
	return wordCount > (config.readingAidsMaxWordCount ?? DEFAULT_MAX_WORD_COUNT);
};
